import { render } from "./v-catalog.vue?vue&type=template&id=5eda1f93"
import script from "./v-catalog.vue?vue&type=script&lang=js"
export * from "./v-catalog.vue?vue&type=script&lang=js"

import "./v-catalog.vue?vue&type=style&index=0&id=5eda1f93&lang=css"
script.render = render

export default script